import React from "react";
import SubMenu from "../../base/SubMenu";
import UberUns from "./UberUns";
import FAQ from "../../home/faq/FAQ";
import Downloads from "../base/Downloads";
import Willkommen from "./Willkommen";
import AGs from "./AGs";

const IGSSekundarstufe = (props) => {

    const willkommenRef = React.createRef()
    const uberunsRef = React.createRef()
    const AGsRef = React.createRef()
    const faqRef = React.createRef()
    const downloadsRef= React.createRef()


    return (
        <div>
            <SubMenu model={{
                background: "#6ede8a",
                items: [
                    { label: <strong>Sekundarstufe I (IGS)</strong>},
                    { label: "Start", onClick: () => window.location.href = "/bildungsangebote/igssekundarstufe"},
                    { label: "Willkommen", onClick: () => willkommenRef.current.scrollIntoView()},
                    { label: "Über Uns", onClick: () => uberunsRef.current.scrollIntoView()},
                    { label: "AGs", onClick: () => AGsRef.current.scrollIntoView()},
                    { label: "FAQ", onClick: () => faqRef.current.scrollIntoView()},
                    { label: "Downloads", onClick: ()=> downloadsRef.current.scrollIntoView()}
                ]
            }}/>
            <div ref={willkommenRef} ><Willkommen/></div>
            <div ref={uberunsRef} ><UberUns/></div>
            <div ref={AGsRef}><AGs/></div>

            <div ref={faqRef}><FAQ/></div>
            <div ref={downloadsRef} className="wrapper wrapperContent" style={{paddingTop: 'calc(var(--header-height))', color:"#488e62"}}>
                <Downloads
                    model={
                        {
                            items: [
                                {label: 'Anmeldeformular', download: 'anmeldeformular.pdf', url: '/assets/sekundarstufe/Schulvertrag_IGSGS_IGS_mai25.pdf'}
                            ]
                        }
                    }/>
            </div>
        </div>
    );
};

export default IGSSekundarstufe;
